<template>
  <div class="category-overview-component">
    <EditableArea
      :content="main"
      :custom-view="CategoryOverviewComponentArea"
      class="category-overview-area"
    />
  </div>
</template>

<script setup>
import { EditableArea } from "@magnolia/vue-editor";
import CategoryOverviewComponentArea from "~/templates/components/cms/CategoryOverviewComponentArea.vue";

defineProps(["main"]);
</script>
